import { createDetailReducer } from '../../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'STAFF',
});
